module.exports = __webpack_public_path__ + "img/compact.0d71dc6c.png";